import { FilterProps } from '../../features/Dashboard/Map/DashboardMap';

export type Principal = {
  adGroupId?: string;
  id: string;
  logoUrl?: string;
  manufacturerName: string;
  name: string;
  pdmEmail: string;
  pdmImage: string;
  pdmLocation: string;
  pdmName: string;
  pdmPhone: string;
  pdmTitle: string;
  portfolioLevel: number;
  disabledFeatures?: string[];
  maintenanceMode?: string[];
  customerData?: {
    [key: string]: string[];
  };
  slug: string;
  settings: {
    customer_portal_insights_view: boolean;
    social_listening_report_view: boolean;
  };
  teamId?: string;
};

export type FilterByPrincipal = Record<string, FilterProps>;

export type Principals = {
  [id: string]: Principal;
};

export type PrincipalInformationAndFeatures = Pick<
  Principal,
  | 'name'
  | 'slug'
  | 'adGroupId'
  | 'portfolioLevel'
  | 'teamId'
  | 'manufacturerName'
  | 'slug'
  | 'id'
  | 'disabledFeatures'
  | 'maintenanceMode'
  | 'customerData'
  | 'logoUrl'
>;

export enum PrincipalModalTypes {
  CREATE,
  EDIT,
}

type FeatureKey = ['disabled', 'allowed', 'maintenance'];

export type FeatureStatuses = {
  [key in FeatureKey[number]]: string[];
};

export type FeatureStatus = {
  [featureId: string]: 'allowed' | 'disabled' | 'maintenance';
};
